import React from "react";
import {
  ButtonVariantProps,
  ButtonVariant,
} from "../../components/atoms/ButtonVariant";

export function UnlockButton({
  content,
  onClick,
  isLoading,
  isDisabled,
  ...props
}: {
  content: string;
} & ButtonVariantProps) {
  return (
    <ButtonVariant
      leftIcon={"bolt"}
      content={content}
      color="red"
      onClick={onClick}
      isLoading={isLoading}
      spam={"spam"}
      minW={"fit-content"}
      textTransform={"none"}
      disabled={isDisabled}
      {...props}
    />
  );
}
